import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {FranchiseesModelService} from '../../Models/Core/franchisees-model.service';

@Injectable({
  providedIn: 'root'
})
export class FranchiseesApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: FranchiseesModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener las franquicias
   *
   */
  public getFranchisees(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('franchiseeStores', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
